import { render, staticRenderFns } from "./UserPrizeLogs.vue?vue&type=template&id=881ab5aa&"
import script from "./UserPrizeLogs.vue?vue&type=script&lang=js&"
export * from "./UserPrizeLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports